<template>
  <div class="set-notification">
    <h1 v-if="!isMobile">
      {{ $route.params.editing ? $t("message.edit") : $t("message.new") }}
      {{ $route.params.title }}
      {{ typeNumber === 8 ? '' : $t("message.notification") }}
    </h1>
    <div class="gradient-divider" />
    <ModalView v-if="showModal" @hide="showModal = false">
      <div class="modal">
        <div
          class="flex"
          style="margin: 10px 30px; justify-content: space-between"
        >
          <h3>{{ $t("message.deleteNotification") }}</h3>
          <img
            class="close"
            src="@/assets/clear.svg?external"
            @click="showModal = false"
          />
        </div>
        <div class="gradient-divider" />
        <div class="modal-text">
          {{ $t("message.theNotificationWillBeDeletedForAllFleetManagers") }}
        </div>
        <div class="action-btn-area">
          <span />
          <div class="flex center">
            <span class="action-button minor" @click="showModal = false">
              {{ $t("message.cancel") }}
            </span>
            <div
              class="action-button major"
              style="width: 106px; margin: 0 16px"
              @click="handleDelete"
            >
              {{ $t("message.delete") }}
            </div>
          </div>
        </div>
      </div>
    </ModalView>
    <div class="content">
      <div class="flex column" style="height: 125px">
        <h3>
          {{ $t("message.name") }}

          <span>*</span>
        </h3>
        <p>
          {{ $t("message.giveMeaningfulName") }}
        </p>
        <input v-model.trim="output.name" class="search-box" />
      </div>
      <div class="line" />
      <div class="flex column" style="padding: 16px 0 32px 0">
        <h3>{{ $t("message.fleets") }}</h3>
        <p>{{ $t("message.chooseWhichFleetsNotification") }}</p>
        <div class="flex column">
          <div
            class="flex"
            style="margin-bottom: 4px; cursor: pointer"
          >
            <svg
              id="gml:icon/radiobutton"
              style="align-self: center"
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.allVehicles !== true"
                fill="var(--grey)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
              />
            </svg>
            {{ $t("message.allFleets") }}
          </div>
          <div
            class="flex"
            style="cursor: pointer"
          >
            <svg
              id="gml:icon/radiobutton"
              style="align-self: center"
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.allVehicles !== false"
                fill="var(--grey)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
              />
            </svg>
            {{ $t("message.selectFleet") }}
          </div>
        </div>
      </div>
      <div class="line" />
      <div v-if="typeNumber === 12" class="flex column" style="padding: 16px 0 32px 0">
        <h3>{{ $t("message.drivers") }}</h3>
        <p>{{ $t("message.chooseWhichDriversNotification") }}</p>
        <div class="flex column">
          <div
            class="flex"
            style="margin-bottom: 4px; cursor: pointer"
          >
            <svg
              id="gml:icon/radiobutton"
              style="align-self: center"
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.allVehicles !== true"
                fill="var(--grey)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
              />
            </svg>
            {{ $t("message.allDrivers") }}
          </div>
          <div
            class="flex"
            style="cursor: pointer"
          >
            <svg
              id="gml:icon/radiobutton"
              style="align-self: center"
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.allVehicles !== false"
                fill="var(--grey)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
              />
            </svg>
            {{ $t("message.selectDrivers") }}
          </div>
        </div>
      </div>
      <div v-else class="flex column" style="padding: 16px 0 32px 0">
        <h3>{{ $t("message.vehicles") }}</h3>
        <p>{{ $t("message.chooseWhichVehiclesNotification") }}</p>
        <div class="flex column">
          <div
            class="flex"
            style="margin-bottom: 4px; cursor: pointer"
            @click="
              output.allVehicles = true;
              output.selectVehicles = [];
              $forceUpdate();
            "
          >
            <svg
              id="gml:icon/radiobutton"
              style="align-self: center"
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.allVehicles !== true"
                fill="var(--grey)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
              />
            </svg>
            {{ $t("message.allVehicles") }}
          </div>
          <div
            class="flex"
            style="cursor: pointer"
            @click="
              output.allVehicles = false;
              showVehicleSelection = true;
              $forceUpdate();
            "
          >
            <svg
              id="gml:icon/radiobutton"
              style="align-self: center"
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.allVehicles !== false"
                fill="var(--grey)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
              />
            </svg>
            {{ $t("message.selectVehiclesManually") }}

            {{
              output.allVehicles === false
                ? ` (${output.selectedVehicles.length})`
                : ""
            }}
            <b
              v-if="output.allVehicles === false"
              @click="showVehicleSelection = true"
              class="edit-btn"
            >
              {{ $t("message.edit") }}
            </b>
          </div>
        </div>
        <ModalView
          v-if="showVehicleSelection"
          @hide="showVehicleSelection = false"
        >
          <VehicleSelection
            :dataset="dataset"
            :selected="output.selectedVehicles"
            @add="addItemToMultichoose($event, 'selectedVehicles')"
            @remove="removeItemFromMultichoose($event, 'selectedVehicles')"
            @mass-action="
              output.selectedVehicles = $event;
              $forceUpdate();
            "
            @done="showVehicleSelection = false"
          />
        </ModalView>
        <!-- <div v-if="output.allVehicles === false" style="min-height: 50px">
          <div
            class="dropdown"
            @click="vehicleDropdownOpen = !vehicleDropdownOpen"
            :class="{ open: vehicleDropdownOpen }"
          >
            <div class="dropdown-selected-option flex">
              <div
                class="multichoose-item"
                v-for="(vehicleName, index) of output.selectedVehicles"
                :key="'H' + index"
              >
                {{ vehicleName }}
                <svg
                  id="gml:icon/tag-remove"
                  @click="
                    removeItemFromMultichoose(vehicleName, 'selectedVehicles')
                  "
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
                  />
                </svg>
              </div>
            </div>
            <svg
              class="dropdown-search"
              id="gml:icon/field-search"
              viewBox="0 0 24 24"
            >
              <path
                d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
              />
            </svg>
            <div class="dropdown-options" v-if="vehicleDropdownOpen">
              <div
                class="option"
                v-for="(vehicle, index) of dataset.vehicles"
                @click="
                  addItemToMultichoose(
                    vehicle['Vehicle Label'],
                    'selectedVehicles'
                  )
                "
                :key="'G' + index"
              >
                {{ vehicle["Vehicle Label"] }}
              </div>
            </div>
          </div>
        </div> 
        v-else -->
      </div>
      <!-- <div class="flex column" style="height: 195px">
        <h3>
          Subscribers
          <span>*</span>
        </h3>
        <p>Choose which vehicles the notification applies to</p>
        <div class="flex">
          <div class="flex center" style="margin-right: 120px;">
            <svg
              id="gml:icon/radiobutton"
              @click="output.allManagers = true; output.onlyMe = false; output.selectManagers = []; $forceUpdate();"
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.allManagers !== true"
                fill="var(--grey)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
              />
            </svg>
            All managers
          </div>
          <div class="flex center" style="margin-right: 120px;">
            <svg
              id="gml:icon/radiobutton"
              @click="output.allManagers = false; output.onlyMe = true; output.selectManagers = []; $forceUpdate();"
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.onlyMe !== true"
                fill="var(--grey)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
              />
            </svg>
            Only me
          </div>
          <div class="flex center">
            <svg
              id="gml:icon/radiobutton"
              @click="output.allManagers = false; output.onlyMe = false; $forceUpdate();"
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.allManagers !== false || output.onlyMe !== false"
                fill="var(--grey)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
              />
            </svg>
            Select managers
          </div>
        </div>
        <div
          v-if="output.allManagers === false && output.onlyMe === false"
          style="min-height: 70px"
        >
          <div
            class="dropdown"
            @click="managerDropdownOpen = !managerDropdownOpen"
            :class="{open: managerDropdownOpen}"
          >
            <div class="dropdown-selected-option flex">
              <div
                class="multichoose-item"
                v-for="(managerName, index) of output.selectedManagers"
                :key="'H' + index"
              >
                {{managerName}}
                <svg
                  id="gml:icon/tag-remove"
                  @click="removeItemFromMultichoose(managerName, 'selectedManagers')"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
                  />
                </svg>
              </div>
            </div>
            <svg class="dropdown-search" id="gml:icon/field-search" viewBox="0 0 24 24">
              <path
                d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
              />
            </svg>
            <div class="dropdown-options" v-if="managerDropdownOpen">
              <div
                class="option"
                v-for="(manager, index) of dataset.managers"
                @click="addItemToMultichoose(manager['Name'], 'selectedManagers')"
                :key="'G' + index"
              >{{manager['Name']}}</div>
            </div>
          </div>
        </div>
        <div v-else style="min-height: 70px" />
      </div> -->
      <div class="line" />
      <!-- Conditions List for Diagnostic Alert -->
      <div class="flex column" v-if="type === '1'">
        <h3 style="margin-top: 26px">{{ $t("message.conditions") }}</h3>
        <div style="font-size: 15px">
          <p>{{ $t("message.diagnosticNotificationsAreTriggeredInTheEvent") }}</p>
          <div class="condition-grid">
            <svg id="gfs:icon1/airbag" viewBox="0 0 24 24">
              <path
                d="M18.5 9.45a1.65 1.65 0 0 1 .34 1.92l-2.46 4.98-2.06-3.45.1-.22 1.36-2.78c.12-.22.28-.41.47-.56a2.83 2.83 0 0 1-1.63-2.56 2.86 2.86 0 0 1 2.88-2.83c1.6 0 2.9 1.27 2.9 2.83 0 1.23-.8 2.27-1.9 2.67zm.87-2.67a1.84 1.84 0 0 0-1.87-1.8 1.84 1.84 0 0 0-1.86 1.8A1.84 1.84 0 0 0 17.5 8.6a1.84 1.84 0 0 0 1.87-1.82zm-6.9.2c0-1.88-1.57-3.42-3.51-3.42S5.45 5.1 5.45 6.98c0 1.9 1.57 3.43 3.51 3.43s3.51-1.54 3.51-3.43zm1.03 0c0 2.46-2.04 4.45-4.54 4.45S4.42 9.44 4.42 6.98a4.5 4.5 0 0 1 4.54-4.44 4.5 4.5 0 0 1 4.54 4.44zm-.34 7.2a.51.51 0 0 1 .89-.5l3.52 6.02a.51.51 0 0 1-.88.52l-3.52-6.03zm4.88-3.21a.77.77 0 0 0-.38-1.03.82.82 0 0 0-1.07.36l-1.25 2.56.96 1.62 1.73-3.52zm-6.51 3.8l-1.64-1.14a.74.74 0 0 0-1.02.15L5 18.7a.7.7 0 0 0 .12.99c.14.1.3.15.47.15.23 0 .45-.1.58-.28l3.44-4.37.4.28 2.69 1.89c.12.1.28.14.44.13l-1.61-2.71zm-4.55 5.41c-.32.44-.85.68-1.39.68a1.86 1.86 0 0 1-1.08-.35 1.74 1.74 0 0 1-.32-2.45l3.88-4.92a1.76 1.76 0 0 1 2.4-.34l1.74 1.2.14.16 2.2 3.68-.35.29c-.6.49-1.47.53-2.1.07l-2.28-1.62-2.84 3.6z"
              ></path>
            </svg>
            <span>{{ $t("message.airbagSystem") }}</span>

            <svg id="gfs:icon1/battery" viewBox="0 0 24 24">
              <path
                d="M4.73 12.55v-.83h4.02v.83H4.73zm12.11 1.55v-1.55h-1.59v-.83h1.6v-1.55h.84v1.55h1.58v.83H17.7v1.55h-.85zm-1.4-9.9h4.7v1.73h2.66v12.41H1.2V5.93h2.66V4.2h4.7v1.73h6.88V4.2zm1 1.73h2.7v-.75h-2.7v.75zm-11.58 0h2.7v-.75h-2.7v.75zM2.2 17.36h19.6V6.91H2.2v10.45z"
              ></path>
            </svg>
            <span>{{ $t("message.lithiumIonBattery") }}</span>

            <svg id="gfs:icon1/brakes" viewBox="0 0 24 24">
              <path
                d="M20 12.05c0-4.3-3.54-7.8-7.92-7.8a7.86 7.86 0 0 0-7.93 7.8c0 4.3 3.55 7.8 7.93 7.8s7.92-3.5 7.92-7.8zm.85 0a8.7 8.7 0 0 1-8.77 8.65 8.7 8.7 0 0 1-8.77-8.65 8.7 8.7 0 0 1 8.77-8.64 8.7 8.7 0 0 1 8.77 8.64zm-2.73-7.73l.73-.96a10.87 10.87 0 0 1 0 17.4l-.73-.96a9.67 9.67 0 0 0 0-15.49zM6.03 19.8l-.73.96a10.92 10.92 0 0 1 0-17.4l.73.96a9.66 9.66 0 0 0 0 15.48zm11.3-7.62a1 1 0 0 1 .08.41v.01c0 .18-.03.34-.1.48a.95.95 0 0 1-.28.35c-.11.1-.25.16-.42.21a1.86 1.86 0 0 1-.54.08c-.28 0-.55-.05-.82-.14a2.24 2.24 0 0 1-.73-.44l.48-.56c.16.14.34.24.51.32.18.08.37.12.58.12.17 0 .3-.03.39-.1a.28.28 0 0 0 .13-.24v-.01a.35.35 0 0 0-.02-.14.28.28 0 0 0-.11-.1 1.26 1.26 0 0 0-.23-.11 3.8 3.8 0 0 0-.37-.1 4.7 4.7 0 0 1-.5-.16 1.38 1.38 0 0 1-.39-.2.8.8 0 0 1-.24-.3 1.01 1.01 0 0 1-.09-.45 1 1 0 0 1 .36-.8c.11-.1.25-.16.4-.22a1.61 1.61 0 0 1 .52-.07c.27 0 .51.04.73.11a2.21 2.21 0 0 1 .63.34l-.42.6a2.74 2.74 0 0 0-.48-.26 1.25 1.25 0 0 0-.47-.1c-.16 0-.28.04-.36.1a.27.27 0 0 0-.11.22c0 .07 0 .12.03.16.02.04.07.08.12.12l.25.1.39.1c.18.05.35.1.5.16.14.06.26.14.36.22.1.08.17.18.22.3zm-4.02.4a.34.34 0 0 0-.14-.3c-.1-.06-.25-.1-.46-.1h-.93v.8h.96c.18 0 .31-.04.42-.1.1-.07.15-.16.15-.3zm-1.53-1.82v.76h.74c.18 0 .32-.03.43-.09.1-.06.15-.15.15-.29a.32.32 0 0 0-.13-.28.7.7 0 0 0-.4-.1h-.79zm1.64 1.02c.21.08.38.2.5.33a.8.8 0 0 1 .18.56c0 .17-.03.32-.1.44a.86.86 0 0 1-.27.3 1.3 1.3 0 0 1-.44.2c-.16.04-.35.06-.55.06H11v-3.6h1.7c.41 0 .73.1.95.32.16.16.25.36.25.6v.02a.85.85 0 0 1-.15.48.8.8 0 0 1-.15.17 1.04 1.04 0 0 1-.18.12zM8 12.16h.98L8.49 11 8 12.16zm.13-2.12h.74l1.57 3.63H9.6l-.34-.81H7.72l-.34.8h-.81l1.56-3.62z"
              ></path>
            </svg>
            <span>{{ $t("message.antilockBrakingSystem") }}</span>

            <svg id="gfs:icon1/def" viewBox="0 0 24 24">
              <path
                d="M11.25 16.44c.83 0 1.5-.67 1.53-1.53.1-1.22-.97-2.87-1.5-3.63-1.4 1.86-1.63 3.01-1.57 3.67.06.84.73 1.5 1.54 1.5zm.02-6.46l.32.38c.09.11 2.14 2.66 2 4.6a2.36 2.36 0 0 1-2.34 2.29 2.37 2.37 0 0 1-2.34-2.23c-.12-1.24.57-2.8 2.05-4.65l.31-.4zm-5-3.85h4.95l-.25-.7c-.01-.04-.04-.1-.07-.11-.07-.04-.16-.05-.31-.05H6.44c-.11 0-.15.02-.16.03l-.01.83zm5.3.83H6.03a.59.59 0 0 1-.58-.54V5.36c0-.3.14-.57.37-.74.17-.12.38-.17.62-.17h4.16c.22 0 .46.01.7.14a1 1 0 0 1 .46.58l.37 1.03a.55.55 0 0 1-.08.52.57.57 0 0 1-.46.24zm-6.9 13.3h13.15V9.24L15.47 6.9h-1.99l-1-2.97a.52.52 0 0 0-.49-.36H5.2a.52.52 0 0 0-.52.53v16.16zm12.1-14.7l-.73.73 2.53 2.54.73-.73-2.53-2.53zm3.7 2.54l-1.83 1.82v11.16H3.85V4.1A1.35 1.35 0 0 1 5.2 2.75H12c.57 0 1.09.37 1.27.92l.8 2.4h1.03l1.67-1.67 3.7 3.7z"
              ></path>
            </svg>
            <span>{{ $t("message.dieselExhaustFluid") }}</span>

            <svg id="gfs:icon1/electricdriveunit" viewBox="0 0 24 24">
              <path
                d="M11.1 13v-1.85h1.86V13H11.1zm7.88-4.43h2.68V7.8h-2.68v.76zm0 1.58h2.68v-.76h-2.68v.76zm0 1.58h2.68v-.76h-2.68v.76zm0 1.57h2.68v-.75h-2.68v.75zm0 1.58h2.68v-.75h-2.68v.75zm2.68 1.58v-.75h-2.7a.4.4 0 0 1-.4.33c-.52 0-1 .15-1.4.42h4.5zm-6.47 1.74a3.4 3.4 0 0 1 2.97-2.96V5.95H8.87a3.4 3.4 0 0 1-2.96 2.97v9.28h9.28zM2.41 16.46h2.68v-.75H2.4v.75zm0-1.58h2.68v-.75H2.4v.75zm0-1.58h2.68v-.75H2.4v.75zm0-1.57h2.68v-.76H2.4v.76zm0-1.58h2.68v-.76H2.4v.76zm0-2.34v.76h2.68v-.04a.41.41 0 0 1 .4-.41c.44 0 .86-.11 1.22-.3h-4.3zm20.67 3c.23 0 .41.18.41.4v1.8a.41.41 0 0 1-.4.42l-.07-.01v1.84a.41.41 0 0 1-.41.41.39.39 0 0 1-.13-.02v1.23a.41.41 0 0 1-.41.4h-5.7a2.56 2.56 0 0 0-.37 1.29 1.6 1.6 0 0 0 0 .16l.03.3H5.09v-1.74h-3.1a.41.41 0 0 1-.4-.41v-.03-1.2a.4.4 0 0 1-.13.02.41.41 0 0 1-.41-.4v-1.85H.98a.41.41 0 0 1-.41-.4v-1.8a.41.41 0 0 1 .41-.41l.07.01V8.97c0-.22.18-.4.4-.4a.4.4 0 0 1 .13.02V7.4c0-.23.19-.41.42-.41h5.62a2.55 2.55 0 0 0 .45-1.42c0-.17-.03-.44-.03-.44h10.94V6.99h3.09c.23 0 .41.18.41.41V8.6a.38.38 0 0 1 .13-.03c.22 0 .4.19.4.41v1.85l.07-.01zM9.83 14.28h4.4v-4.4h-4.4v4.4zm4.82-5.23h.4v6.05H9.02V9.05h5.64z"
              ></path>
            </svg>
            <span>{{ $t("message.electricDriveUnit") }}</span>

            <svg id="gfs:icon1/emission" viewBox="0 0 24 24">
              <path
                d="M8.79 15.1V9.8l5.26-5.25h6.32v.96h-5.93l-4.69 4.7v5.92H11a2.9 2.9 0 0 1 2.85-2.4 2.9 2.9 0 0 1 2.86 2.4h3.67v.97H16.7a2.9 2.9 0 0 1-2.86 2.4 2.9 2.9 0 0 1-2.85-2.4H8.8v-1.16H7.57v-.84h1.22zm6.99 1.52c0-1.07-.87-1.93-1.94-1.93a1.93 1.93 0 0 0-1.93 1.93 1.93 1.93 0 0 0 1.93 1.92c1.07 0 1.94-.86 1.94-1.93zM6.07 15.1v.84H3v-.84h3.07zm1.22-.55l-.6.59-1.36-1.36.6-.6 1.36 1.36zM5.62 17.3L7 15.93 5.62 17.3z"
              ></path>
            </svg>
            <span>{{ $t("message.emissionsSystem") }}</span>

            <svg id="gfs:icon1/engine" viewBox="0 0 24 24">
              <path
                d="M6.96 3.6v1.21h3.33V6.7H6.03v2.34h-1.6v3.25H3.07V9.1H1.8v7.19h1.26V13.1h1.38v3.2h2.64l3.03 2.9h7.73v-2.95h4.36v-5.8h-3.4V9.05h-2.03V6.7h-5.63V4.8h3.33V3.6H6.96zM5.29 9.85h1.58l.01-2.34h9.04v2.34h2.02v1.42h3.4v4.17H17v2.95h-6.53l-3.03-2.9H5.3V9.85z"
              ></path>
            </svg>
            <span>{{ $t("message.engineAndTransmission") }}</span>

            <svg id="gfs:icon1/oil" viewBox="0 0 24 24">
              <path
                d="M8.6 7.02v1.3H12l3.18 2.25 4-2.22.23-.06h3.17l-7.33 8.37H4.08v-9.5H1.94v-.97h3.1v2.12h2.6v-1.3H6.16v-.95h3.92v.96H8.6zM5.04 9.27v6.43h9.77l5.65-6.45h-.93l-4.42 2.45-3.42-2.43H5.04zm12.92 6.88c-.2.3-.38.6-.52.88-.22.44-.34.8-.34 1.06 0 .85.63 1.52 1.4 1.52.76 0 1.4-.67 1.4-1.52h.47-.48c0-.26-.12-.62-.34-1.06a8.64 8.64 0 0 0-.51-.88l-.54-.75c-.19.24-.37.5-.54.75zm2.41 1.94h.48a2.42 2.42 0 0 1-2.35 2.48 2.42 2.42 0 0 1-2.36-2.48c0-.44.16-.93.45-1.5.15-.3.35-.63.57-.97a14.76 14.76 0 0 1 .97-1.3l.37-.42.36.42a14.76 14.76 0 0 1 .97 1.3c.23.34.42.66.58.97.28.57.44 1.06.44 1.5h-.48z"
              ></path>
            </svg>
            <span>{{ $t("message.oilLife") }}</span>

            <svg id="gfs:icon1/onstar" viewBox="0 0 24 24">
              <path
                fill-rule="evenodd"
                d="M18.96 10.48v.78l-.85.84h-1.99v.9h2.33l.51-.5v3.12l-.77.66H6l-.77-.66v-3.17l.57.55h2.33v-.9H6.14l-.91-.9v-.72h.61a.44.44 0 0 0 .41-.3l.18-.52.26 1.1H17.5l.26-1.1.18.52c.06.18.23.3.41.3h.61zm0 7.93h-2.5v-1.23h1.94a.44.44 0 0 0 .28-.1l.28-.24v1.57zm-11.22 0h-2.5v-1.57l.28.24a.44.44 0 0 0 .27.1h1.95v1.23zM7.56 6.38h9.07l.6 1.73-.41 1.74H7.38l-.41-1.74.6-1.73zm9.79-.6l.69 2h1.95v.9h-1.64l.31.9h.74a.44.44 0 0 1 .44.45v5.8l-.01.03v3a.44.44 0 0 1-.43.45h-3.38a.44.44 0 0 1-.44-.45v-1.68H8.62v1.68a.44.44 0 0 1-.44.45H4.8a.44.44 0 0 1-.44-.45v-2.97-.03-5.83a.44.44 0 0 1 .43-.45h.74l.31-.9H4.2v-.9h1.95l.7-2a.44.44 0 0 1 .4-.3h9.69c.18 0 .35.12.41.3zm1.13.6a2.02 2.02 0 0 0-2-2.01l-.05-.9h.05a2.9 2.9 0 0 1 2.87 2.88l-.87.03zm-2-4.46c2.37 0 4.33 2 4.37 4.44l-.87.01a3.57 3.57 0 0 0-3.5-3.55l-.05-.9h.05zm0-1.62a6.05 6.05 0 0 1 5.92 6.06l-.87.01a5.16 5.16 0 0 0-5.05-5.17l-.05-.9h.05z"
              ></path>
            </svg>
            <span>{{ $t("message.onStarSystem") }}</span>

            <svg id="gfs:icon1/regen" viewBox="0 0 24 24">
              <path
                fill-rule="nonzero"
                d="M9 8.545V6l2.98-.003L11.994 4h.997v1.997h3.023V20H9v-2.6m-1-9h1v9H8v-9zm0 8.168V20c0 .666.361 1 1 1h7.013c.647 0 .987-.343.987-1V5.997C17 5.34 16.652 5 16.013 5H14V3h-3v2l-2 .014c-.639 0-1 .326-1 .983v2.548 M15 13.079V19h-5v-1.6l3.017-4.321H15zm-6.4-.522l-2.323-2.68a.559.559 0 0 1 0-.732.42.42 0 0 1 .633 0l2.866 3.306a.84.84 0 0 1 0 1.1L6.91 16.859a.419.419 0 0 1-.634 0 .558.558 0 0 1 0-.73L8.6 13.447H.445a.445.445 0 1 1 0-.89H8.6z"
              ></path>
            </svg>
            <span>{{ $t("message.regenerativeBrakingSystem") }}</span>

            <svg id="gfs:icon1/sli" viewBox="0 0 24 24">
              <path
                d="M9.07 6.17h5.73v-2.2h3.7v2.2h3.36v4.18h-1.13v7.9H3.15v-7.9H2V6.17h3.35v-2.2h3.7v2.2zm6.23 5.76v-1.54h.84v1.54h1.54v.84h-1.54v1.54h-.84v-1.54h-1.54v-.84h1.54zm5.68-4.88H2.88v2.42h1.15v7.9h15.82v-7.9h1.13V7.05zM6.33 12.77v-.84h3.92v.84H6.33zM17.66 6.1v-1.3h-2.02v1.3h2.02zm-11.45 0h2.02v-1.3H6.2v1.3z"
              ></path>
            </svg>
            <span>{{ $t("message.vehicleBattery") }}</span>

            <svg id="gfs:icon1/stability" viewBox="0 0 24 24">
              <path
                d="M4.76 11.24l-.05 1 .74.68.63.03 2.01.1 3.86.21 3.6.2 2.2.1.82-.6.05-.98-13.86-.74zm.05-.88l1.86.1-1.8-1.18-.06 1.08zm12 .64l1.86.1.06-1.08-1.92.98zm-8.77 2.94l-.1 2.05-1.25-.06.66.7c.74.78.38 2.06-.75 2.37l-2.24.16a.34.34 0 0 0-.26.55l2.67 3.48-.7.54-2.67-3.48c-.6-.78-.08-1.9.9-1.97l2.15-.15a.54.54 0 0 0 .26-.9l-1.3-1.37-1.77-.1.17-3.14.33-6.28 1.19.06.36-.84-1.66-.09.05-.88 1.97.1.92-2.17 5.75.3 4.64.24.68 2.27 1.98.1-.05.89-1.66-.1.27.89 1.18.06-.28 5.18-.05.9v.2l-.18 3.14-1.9-.1.68.71c.74.79.38 2.08-.75 2.38l-2.24.16a.34.34 0 0 0-.26.55l2.67 3.48-.7.54-2.67-3.48c-.6-.78-.08-1.9.9-1.97l2.15-.15a.54.54 0 0 0 .26-.9l-1.32-1.39-1.11-.05.1-2.06-3.85-.2-3.17-.17zm-.88-.05l-1.12-.06-1-.05-.4-.36-.08 1.51 2.54.14.06-1.18zm4.4-7.2v-.01l5.17.28.48-1.35-.51-1.7-5.14-.27-4.02-.21-.69 1.63.33 1.39 4.38.23zm.75.91l-5.84-.3-.2-.86-.37.88-.92-.05-.06 1 2.42 1.57 8.87.47L18.78 9l.06-1-.93-.05-.27-.9-.3.82-5.03-.27zm5.76 6.87l-2.12-.11-.06 1.17 2.53.14.08-1.51-.43.3z"
              ></path>
            </svg>
            <span>{{ $t("message.stabilityControlSystem") }}</span>

            <svg id="gfs:icon1/tires" viewBox="0 0 24 24">
              <path
                d="M5.11 19.08l-.3.21c-.3.2-.4.3-.49.39l-.05.04a.33.33 0 0 0-.13.26v.2c0 .17.13.3.3.3h15.1c.17 0 .3-.13.3-.3v-.2c0-.03 0-.08-.07-.2a.36.36 0 0 0-.14-.1l-.2-.13c-.5-.33-.73-.54-.8-.93a.9.9 0 0 1 .16-.7 9.66 9.66 0 0 0 1.85-5.54c0-4.92-3.86-8.93-8.6-8.93-4.75 0-8.61 4-8.61 8.93 0 1.97.6 3.83 1.74 5.4.16.2.25.56.21.82a.7.7 0 0 1-.27.48zm15.47.05c.11.12.18.24.2.37.06.15.1.31.1.48v.2c0 .75-.6 1.36-1.33 1.36H4.44c-.74 0-1.33-.61-1.33-1.37v-.19c0-.42.2-.83.5-1.06.13-.15.3-.27.63-.5l.08-.06a10.13 10.13 0 0 1-1.92-5.98c0-5.5 4.32-9.98 9.64-9.98 5.3 0 9.63 4.48 9.63 9.98 0 2.08-.66 4.12-1.97 6.08l.13.1.16.1.1.07c.19.1.36.23.5.4zm-9.8-10.45l-.04-1.1a1.08 1.08 0 0 0-.22.03c-1.75.47-2.36 1.62-2.58 2.04a1.34 1.34 0 0 1-.06.1l-.02.05a.4.4 0 0 0 .07.03l1.02.3 1.54.45c.1-.1.21-.2.33-.27l-.04-1.38v-.25zm-3.05 1.77c-.25-.08-.42-.22-.5-.41-.07-.19-.04-.4.08-.61l.04-.08c.24-.45.97-1.83 3-2.37.23-.06.57-.13.82.07.11.09.24.26.23.56l.02.72.02.58.04 1.4c0 .35-.16.48-.26.52a1.4 1.4 0 0 0-.32.28.44.44 0 0 1-.35.14.78.78 0 0 1-.25-.04l-1.8-.53-.65-.2-.12-.03zm8.08-.96a.93.93 0 0 0-.1-.2c-1-1.5-2.28-1.72-2.76-1.8l-.11-.02a.3.3 0 0 0-.05 0 .53.53 0 0 0-.01.07l.02.6v.35l.06 1.7c.13.06.25.14.36.22l.96-.34.36-.13a116 116 0 0 1 1.27-.45zm-2.75-2.65c.5.09 2.04.35 3.2 2.1.13.2.3.5.18.8-.05.12-.17.3-.46.38l-.8.29-.42.15a155.65 155.65 0 0 1-1.33.48.82.82 0 0 1-.26.04.43.43 0 0 1-.33-.12 1.38 1.38 0 0 0-.36-.22c-.09-.04-.28-.16-.28-.54l-.06-1.93-.01-.56a12.55 12.55 0 0 1 0-.17c0-.26.08-.47.23-.6.16-.12.36-.16.6-.12l.1.02zm-2.93 6.1a2.01 2.01 0 0 1-.15-.39l-1.06-.3-.27-.09a72.1 72.1 0 0 1-1.3-.37l-.02-.01a1.01 1.01 0 0 0-.03.22 3.82 3.82 0 0 0 1.16 3.07l.08.08a.38.38 0 0 0 .03.04.3.3 0 0 0 .06-.07l.6-.87.9-1.3zm.54.38l-.99 1.43-.42.62-.1.15c-.16.2-.35.32-.55.33H8.6a.72.72 0 0 1-.55-.25l-.06-.07c-.36-.37-1.45-1.48-1.35-3.57.01-.24.06-.58.33-.75.11-.08.3-.15.6-.04a231.6 231.6 0 0 0 2.6.75c.34.11.42.3.43.41.03.13.08.26.16.4.05.07.14.29-.09.59zm3.3-1.01a2.13 2.13 0 0 1-.1.4l.84 1.1.3.38.53.68a.03.03 0 0 0 .01.01.83.83 0 0 0 .13-.13l.02-.03c1.14-1.4.95-2.68.88-3.16l-.01-.11a.32.32 0 0 0-.01-.05.39.39 0 0 0-.08.02l-.32.11-.26.1-1.93.68zm2.13-1.45l.17-.07c.26-.08.48-.06.65.05.12.07.26.23.3.53l.01.1c.08.5.3 2.03-1.01 3.66-.15.19-.38.43-.69.43a.66.66 0 0 1-.54-.32c-.01-.03-.2-.28-.44-.57l-.36-.46c-.4-.53-.8-1.02-.86-1.1-.2-.29-.15-.49-.1-.58.05-.12.09-.27.1-.41 0-.1.06-.32.42-.43l1.93-.68.42-.15zm-2.15 5.32a.45.45 0 0 0-.04-.07l-.36-.46L12.28 14l-.42.03-.54.78-.24.36c-.6.88-.74 1.08-.77 1.1v.02l.2.1c1.69.64 2.86.06 3.3-.15l.1-.05.04-.02zm.12-.94l.37.48c.16.21.21.43.16.63-.05.2-.2.35-.42.45l-.09.04c-.3.15-1.03.5-2.06.5a4.99 4.99 0 0 1-1.76-.33c-.23-.09-.54-.24-.62-.54-.04-.13-.05-.35.15-.59l.64-.94.09-.13.8-1.16c.2-.28.4-.29.51-.27.14.01.28 0 .43-.03.09-.02.32-.04.54.26.08.12.91 1.18 1.26 1.63zm-2.39-3.28a.28.28 0 0 0 .28.28c.16 0 .29-.13.29-.28a.28.28 0 0 0-.29-.28.28.28 0 0 0-.28.28zm-.66 0a.94.94 0 0 1 1.89 0 .94.94 0 0 1-1.89 0zm6.65.08a5.8 5.8 0 0 0-5.74-5.84 5.8 5.8 0 0 0-5.75 5.84 5.8 5.8 0 0 0 5.75 5.84 5.8 5.8 0 0 0 5.74-5.84zm-5.74-6.55c3.55 0 6.44 2.94 6.44 6.55s-2.89 6.55-6.44 6.55c-3.55 0-6.44-2.94-6.44-6.55s2.89-6.55 6.44-6.55z"
              ></path>
            </svg>
            <span>{{ $t("message.tirePressureSensor") }}</span>
          </div>
        </div>
        <p style="margin-bottom: 16px; font-size: 15px">
          {{ $t("message.forSupportedVehicles") }}
        </p>
      </div>
      <!-- Conditions List for Driver Behavior Notification -->
      <div class="flex column" style="height: 100%" v-else-if="type === '7'">
        <h3 style="margin-top: 26px">{{ $t("message.conditions") }}</h3>
        <p style="margin-bottom: 26px">
          {{ $t("message.chooseWhichEventsTrigger") }}
        </p>
        <div class="toggle-grid">
          <!-- Hard Braking -->
          <svg id="gfs:icon1/i-hard-brake" viewBox="0 0 24 24">
            <path
              fill-rule="evenodd"
              d="M12.2 4.4a7.6 7.6 0 110 15.2 7.6 7.6 0 010-15.2zm7.18 1.23a9.57 9.57 0 01-.04 12.8l-.9-.8a8.36 8.36 0 00.04-11.2l.9-.8zM5.07 5.58l.9.8a8.36 8.36 0 00-.03 11.23l-.89.8a9.56 9.56 0 01.02-12.84zm7.13.02a6.4 6.4 0 100 12.8 6.4 6.4 0 000-12.8zm0 8.9a.83.83 0 110 1.67.83.83 0 010-1.67zm.63-6.67v5h-1.26v-5h1.25z"
            ></path>
          </svg>
          <div class="item">{{ $t("message.hardBrakeDetected") }}</div>
          <div class="flex justify-end btn-container">
            <div
              style="width: 30px"
              v-bind:style="
                $i18n.locale !== 'en'
                  ? { position: 'relative', left: '-42px' }
                  : {}
              "
            >
              {{ toggles.brake ? $t("message.on") : $t("message.off") }}
            </div>
            <ToggleButton
              v-model="toggles.brake"
              :width="36"
              :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
            />
          </div>

          <div class="separator" />
          <!-- Hard Acceleration -->
          <svg id="gfs:icon1/i-hard-acceleration" viewBox="0 0 24 24">
            <path
              fill-rule="evenodd"
              d="M21 3.52l.1.1v1.07l-.1.1-6.4-.03-5.11 5.2v6.55h1.17l.02-.1a3.3 3.3 0 012.8-2.58l.2-.01h.18a3.3 3.3 0 013.2 2.59l.01.1H21l.1.1v1.08l-.1.1h-3.93l-.02.1a3.3 3.3 0 01-2.82 2.57l-.19.02h-.18a3.28 3.28 0 01-3.18-2.6l-.02-.1H8.34l-.1-.1V16.5H3.87l-.1-.1v-.94l.1-.1h4.37v-3.28H2.06l-.1-.1v-.94l.1-.1h6.18l.02-1.49 2.32-2.37H5.8l-.1-.1v-.94l.1-.1 5.85.03 2.43-2.44H21zm-7.14 11.57c-1.1 0-2.01.92-2.01 2.06 0 1.13.9 2.06 2 2.06 1.13 0 2.03-.92 2.03-2.06 0-1.14-.9-2.06-2.02-2.06z"
            ></path>
          </svg>
          <div class="item">
            {{ $t("message.hardAccelerationDetected") }}
          </div>
          <div class="flex justify-end btn-container">
            <div
              style="width: 30px"
              v-bind:style="
                $i18n.locale !== 'en'
                  ? { position: 'relative', left: '-42px' }
                  : {}
              "
            >
              {{ toggles.accel ? $t("message.on") : $t("message.off") }}
            </div>
            <ToggleButton
              v-model="toggles.accel"
              :width="36"
              :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
            />
          </div>
          <div class="separator" />
          <!-- Driver Seatbelt -->
          <svg id="gfs:icon1/i-seatbelt-unbuckled" viewBox="0 0 24 24">
            <path
              fill-rule="evenodd"
              d="M7.29 11.4l5.66 5.65a.6.6 0 010 .85l-2.83 2.83a.6.6 0 01-.85 0l-.86-.87-2.77 2.77-.85-.85 2.4-2.4-1.97-1.98-2.4 2.4-.86-.85 2.77-2.76-1.12-1.12a.6.6 0 010-.85l2.83-2.83a.6.6 0 01.85 0zm-.42 1.26l-1.98 1.98 4.8 4.81 1.98-1.98-4.8-4.8zm11.78-10.4l.85.85-3.11 3.11 1.98 1.98 3.11-3.1.85.84-3.17 3.17.84.84c.2.21.23.54.07.77l-.07.08-2.81 2.81c-.1.1-.23.18-.39.2h-.1l-2.4-.15-1.38 1.39a.6.6 0 01-.76.07l-.08-.07-2.83-2.83a.6.6 0 01-.07-.77l.07-.08 1.38-1.38-.12-2.26a.6.6 0 01.09-.53l.06-.07L13.5 4.3a.6.6 0 01.76-.07l.09.07 1.14 1.14 3.17-3.18zM11.8 9.1l.05 1.09a.6.6 0 01-.1.38l-.07.07-1.15 1.15 1.98 1.98 1.15-1.14a.6.6 0 01.36-.18h.1l1.1.07-3.42-3.42zm.88 1.83l.76.76-1.03 1.03-.76-.77 1.02-1.02zm1.25-5.36l-1.98 1.98 4.8 4.8 1.98-1.97-4.8-4.81zM8.07 4a.6.6 0 01.64.58l.39 4.15-1.24.1-.27-2.73-4.65 5.16-.08-.1a1.23 1.23 0 010-1.64l3.81-4.24-2.74.01-.03-1.24z"
            ></path>
          </svg>
          <div class="item">
            {{ $t("message.seatbeltNotifies") }}
            <div style="color: var(--grey)">
              * {{ $t("message.supportedOnlyForEnrolled") }}
              <b>{{ $t("message.inVehicleCoaching") }}</b>
            </div>
          </div>
          <div class="flex justify-end btn-container">
            <div
              style="width: 30px"
              v-bind:style="
                $i18n.locale !== 'en'
                  ? { position: 'relative', left: '-42px' }
                  : {}
              "
            >
              {{ toggles.seatbelt ? $t("message.on") : $t("message.off") }}
            </div>
            <ToggleButton
              v-model="toggles.seatbelt"
              :width="36"
              :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
            />
          </div>
          <!-- <button class="learn-more action-button">
            {{ $t("message.learnMore") }}
          </button> -->

          <div class="separator" />
          <!-- Fixed Speed -->
          <svg id="gfs:icon1/i-fixed-speed" viewBox="0 0 24 24">
            <path
              fill-rule="evenodd"
              d="M12.2 11.67c.2 0 .37.17.36.38l.84 6.4a2.5 2.5 0 11-2.66-.1l.16-.09.9-6.22c.01-.2.18-.37.4-.37zm2.99-4.64a9.8 9.8 0 015.01 14.61l-.18.29h-4.56c.16-.4.25-.82.27-1.25h3.6a8.54 8.54 0 10-14.65 0h3.6c.01.43.1.85.26 1.25H3.98l-.18-.29a9.8 9.8 0 0111.39-14.6zM12 19.22a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM10.52 2.39l3.11.05-1.6 2.66-1.51-2.71z"
            ></path>
          </svg>
          <div class="item">
            {{ $t("message.vehicleExceedsFixedSpeed") }}
            <svg
              @click="goToSpeedPage"
              id="gfs:icon1/i-settings"
              viewBox="0 0 24 24"
              style="
                fill: var(--blue);
                cursor: pointer;
                width: 20px;
                height: 20px;
                margin: 0 0 -5px 3px;
              "
            >
              <path
                d="M19.392 12.833a7.108 7.108 0 0 0 0-1.666c-.043-.324.072-.65.308-.875l1.058-1.025-2-3.475-1.425.375A1.05 1.05 0 0 1 16.425 6a7.383 7.383 0 0 0-1.467-.833 1.067 1.067 0 0 1-.6-.667L14 3.042h-4L9.642 4.5c-.084.312-.305.57-.6.7-.52.22-1.012.5-1.467.833a1.05 1.05 0 0 1-.908.134l-1.425-.384-2 3.475L4.3 10.283c.239.228.354.557.308.884a7.108 7.108 0 0 0 0 1.666c.043.324-.072.65-.308.875l-1.058 1.034 2 3.475 1.425-.384a1.05 1.05 0 0 1 .908.167c.456.333.948.612 1.467.833.296.126.517.381.6.692L10 20.958h4l.358-1.458c.084-.312.305-.57.6-.7a7 7 0 0 0 1.467-.833 1.05 1.05 0 0 1 .908-.134l1.425.409 2-3.475-1.058-1.025a1.025 1.025 0 0 1-.308-.909zm-1.242-1.541c.026.232.04.466.042.7a6.292 6.292 0 0 1-.042.691 2.308 2.308 0 0 0 .675 1.925l.367.35-1.034 1.775-.483-.133a2.267 2.267 0 0 0-2 .367 5.942 5.942 0 0 1-1.217.708 2.275 2.275 0 0 0-1.308 1.542l-.125.483h-2.05l-.125-.483a2.275 2.275 0 0 0-1.308-1.542A5.942 5.942 0 0 1 8.325 17a2.267 2.267 0 0 0-2-.367l-.483.134-1.034-1.8.367-.35A2.3 2.3 0 0 0 5.85 12.7a6.575 6.575 0 0 1 0-.7 6.292 6.292 0 0 1 0-.692 2.308 2.308 0 0 0-.675-1.925l-.367-.35 1.034-1.775.483.134a2.267 2.267 0 0 0 2-.392c.377-.282.785-.52 1.217-.708A2.275 2.275 0 0 0 10.85 4.75l.125-.483h2.05l.125.483a2.275 2.275 0 0 0 1.35 1.567c.416.183.81.412 1.175.683a2.267 2.267 0 0 0 2 .367l.483-.134 1.034 1.775-.367.35a2.3 2.3 0 0 0-.675 1.942v-.008zM12 8.042a3.775 3.775 0 1 0-.017 7.55A3.775 3.775 0 0 0 12 8.042zm0 6.291a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
              ></path>
            </svg>
          </div>
          <div class="flex justify-end btn-container">
            <div
              style="width: 30px"
              v-bind:style="
                $i18n.locale !== 'en'
                  ? { position: 'relative', left: '-42px' }
                  : {}
              "
            >
              {{ toggles.fixedSpeed ? $t("message.on") : $t("message.off") }}
            </div>
            <ToggleButton
              v-model="toggles.fixedSpeed"
              :width="36"
              :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
            />
          </div>

          <div class="separator" />
          <!-- Road Speed -->
          <svg id="gfs:icon1/i-road-speed" viewBox="0 0 24 24">
            <path
              fill-rule="evenodd"
              d="M8.18 4.5l-3.71 16H3l3.72-16h1.46zm9.4 0l3.7 16h-1.46l-3.72-16h1.47zm-4.65 12.8v2.95H11.5V17.3h1.42zm0-5.9v2.95H11.5V11.4h1.42zm0-5.9v2.95H11.5V5.5h1.42z"
            ></path>
          </svg>
          <div class="flex" style="align-items: center">
            <div class="item">
              {{ $t("message.vehicleExceeds5mph") }}
              <div style="color: var(--grey)">
                * {{ $t("message.whereAvailable") }}
              </div>
            </div>
            <svg
              @click="goToSpeedPage"
              id="gfs:icon1/i-settings"
              viewBox="0 0 24 24"
              style="
                fill: var(--blue);
                cursor: pointer;
                width: 20px;
                height: 20px;
                margin: 0 0 0 5px;
              "
            >
              <path
                d="M19.392 12.833a7.108 7.108 0 0 0 0-1.666c-.043-.324.072-.65.308-.875l1.058-1.025-2-3.475-1.425.375A1.05 1.05 0 0 1 16.425 6a7.383 7.383 0 0 0-1.467-.833 1.067 1.067 0 0 1-.6-.667L14 3.042h-4L9.642 4.5c-.084.312-.305.57-.6.7-.52.22-1.012.5-1.467.833a1.05 1.05 0 0 1-.908.134l-1.425-.384-2 3.475L4.3 10.283c.239.228.354.557.308.884a7.108 7.108 0 0 0 0 1.666c.043.324-.072.65-.308.875l-1.058 1.034 2 3.475 1.425-.384a1.05 1.05 0 0 1 .908.167c.456.333.948.612 1.467.833.296.126.517.381.6.692L10 20.958h4l.358-1.458c.084-.312.305-.57.6-.7a7 7 0 0 0 1.467-.833 1.05 1.05 0 0 1 .908-.134l1.425.409 2-3.475-1.058-1.025a1.025 1.025 0 0 1-.308-.909zm-1.242-1.541c.026.232.04.466.042.7a6.292 6.292 0 0 1-.042.691 2.308 2.308 0 0 0 .675 1.925l.367.35-1.034 1.775-.483-.133a2.267 2.267 0 0 0-2 .367 5.942 5.942 0 0 1-1.217.708 2.275 2.275 0 0 0-1.308 1.542l-.125.483h-2.05l-.125-.483a2.275 2.275 0 0 0-1.308-1.542A5.942 5.942 0 0 1 8.325 17a2.267 2.267 0 0 0-2-.367l-.483.134-1.034-1.8.367-.35A2.3 2.3 0 0 0 5.85 12.7a6.575 6.575 0 0 1 0-.7 6.292 6.292 0 0 1 0-.692 2.308 2.308 0 0 0-.675-1.925l-.367-.35 1.034-1.775.483.134a2.267 2.267 0 0 0 2-.392c.377-.282.785-.52 1.217-.708A2.275 2.275 0 0 0 10.85 4.75l.125-.483h2.05l.125.483a2.275 2.275 0 0 0 1.35 1.567c.416.183.81.412 1.175.683a2.267 2.267 0 0 0 2 .367l.483-.134 1.034 1.775-.367.35a2.3 2.3 0 0 0-.675 1.942v-.008zM12 8.042a3.775 3.775 0 1 0-.017 7.55A3.775 3.775 0 0 0 12 8.042zm0 6.291a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
              ></path>
            </svg>
          </div>
          <div class="flex justify-end btn-container">
            <div
              style="width: 30px"
              v-bind:style="
                $i18n.locale !== 'en'
                  ? { position: 'relative', left: '-42px' }
                  : {}
              "
            >
              {{ toggles.roadSpeed ? $t("message.on") : $t("message.off") }}
            </div>
            <ToggleButton
              v-model="toggles.roadSpeed"
              :width="36"
              :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
            />
          </div>

          <div class="separator" />
          <!-- Idle -->
          <svg id="gfs:icon1/vehicle-idling" viewBox="0 0 24 24">
            <path d="M22 4.95l.05.05L22 6.13l-6.44-.02-5.12 5.23-.05 6.6 1.3.04a3.24 3.24 0 013.17-2.74 3.16 3.16 0 013.1 2.53l.03.17 4.06.05-.05 1.13-3.96-.04a3.24 3.24 0 01-3.18 2.74c-1.51 0-2.8-1.09-3.09-2.53l-.03-.17-2.45-.05.05-1.24-1.39-.05.05-1 1.29.05.01-5.97 5.79-5.91H22zm-7.14 11.47c-1.13 0-2.06.95-2.06 2.11s.93 2.1 2.06 2.1c1.15 0 2.07-.94 2.07-2.1s-.92-2.11-2.07-2.11zm-10.52-.97a1.55 1.55 0 110 3.1 1.55 1.55 0 010-3.1zm0 1.1a.45.45 0 100 .9.45.45 0 000-.9zm1.2-6.98l.14.08.14.08c.85.59 1.15 1.7.72 2.62l-.08.15v.09c0 .28-.08.56-.22.8a1.72 1.72 0 01-2.22.67L3.87 14l-.13-.08c-.3-.22-.53-.52-.65-.86l-.04-.15-.01-.06-.08-.1a2.1 2.1 0 012.58-3.17zm-1.69 1.45a.9.9 0 00.08 1.01l.25.27.02.22c0 .17.11.34.28.43.26.15.58.08.72-.16a.46.46 0 00.06-.24v-.08l-.04-.27.13-.2.06-.08a.9.9 0 00-1.56-.9zm3.4-8.97l.15.09.08.07.11-.03a2.33 2.33 0 011.9.38l.14.12.14.12.13.14.12.15.06.1h.02a1.6 1.6 0 01.66 2.37l-.09.12-.1.12c-.23.21-.5.36-.8.42l-.16.03-.03-.01-.13.1c-.16.1-.34.18-.53.24l-.2.05-.1-.03v.06A2.1 2.1 0 015.3 8.55l-.14-.11-.13-.12a2.11 2.11 0 01-.48-.74l-.06-.16v-.09l-.03-.02a2.6 2.6 0 01-.64-2.8l.08-.17.04-.07-.02-.11c-.03-.52.1-1.02.4-1.44l.12-.16.1-.11c.7-.72 1.8-.87 2.7-.4zM5.35 3.34c-.18.21-.26.49-.22.77l.06.38-.12.2a1.4 1.4 0 00.19 1.72l.1.1.23.2.03.23a.9.9 0 001.8-.2l-.08-.38.12-.2.1-.18.03-.1.18-.42.42.02c.23 0 .46-.06.65-.19l.1-.08.22-.18.24.02a.4.4 0 00.3-.7.38.38 0 00-.11-.07l-.34-.1-.11-.23a1.17 1.17 0 00-.29-.36c-.3-.25-.72-.33-1.07-.21l-.13.05-.48.19-.24-.33-.07-.06a1.08 1.08 0 00-1.5.1z"></path>
          </svg>
          <div class="flex" style="align-items: center">
            <div class="item">
              {{ $t('message.idleNotifies') }}
            </div>
            <svg
              @click="goToSpeedPage"
              id="gfs:icon1/i-settings"
              viewBox="0 0 24 24"
              style="
                fill: var(--blue);
                cursor: pointer;
                width: 20px;
                height: 20px;
                margin: 0 0 0 5px;
              "
            >
              <path
                d="M19.392 12.833a7.108 7.108 0 0 0 0-1.666c-.043-.324.072-.65.308-.875l1.058-1.025-2-3.475-1.425.375A1.05 1.05 0 0 1 16.425 6a7.383 7.383 0 0 0-1.467-.833 1.067 1.067 0 0 1-.6-.667L14 3.042h-4L9.642 4.5c-.084.312-.305.57-.6.7-.52.22-1.012.5-1.467.833a1.05 1.05 0 0 1-.908.134l-1.425-.384-2 3.475L4.3 10.283c.239.228.354.557.308.884a7.108 7.108 0 0 0 0 1.666c.043.324-.072.65-.308.875l-1.058 1.034 2 3.475 1.425-.384a1.05 1.05 0 0 1 .908.167c.456.333.948.612 1.467.833.296.126.517.381.6.692L10 20.958h4l.358-1.458c.084-.312.305-.57.6-.7a7 7 0 0 0 1.467-.833 1.05 1.05 0 0 1 .908-.134l1.425.409 2-3.475-1.058-1.025a1.025 1.025 0 0 1-.308-.909zm-1.242-1.541c.026.232.04.466.042.7a6.292 6.292 0 0 1-.042.691 2.308 2.308 0 0 0 .675 1.925l.367.35-1.034 1.775-.483-.133a2.267 2.267 0 0 0-2 .367 5.942 5.942 0 0 1-1.217.708 2.275 2.275 0 0 0-1.308 1.542l-.125.483h-2.05l-.125-.483a2.275 2.275 0 0 0-1.308-1.542A5.942 5.942 0 0 1 8.325 17a2.267 2.267 0 0 0-2-.367l-.483.134-1.034-1.8.367-.35A2.3 2.3 0 0 0 5.85 12.7a6.575 6.575 0 0 1 0-.7 6.292 6.292 0 0 1 0-.692 2.308 2.308 0 0 0-.675-1.925l-.367-.35 1.034-1.775.483.134a2.267 2.267 0 0 0 2-.392c.377-.282.785-.52 1.217-.708A2.275 2.275 0 0 0 10.85 4.75l.125-.483h2.05l.125.483a2.275 2.275 0 0 0 1.35 1.567c.416.183.81.412 1.175.683a2.267 2.267 0 0 0 2 .367l.483-.134 1.034 1.775-.367.35a2.3 2.3 0 0 0-.675 1.942v-.008zM12 8.042a3.775 3.775 0 1 0-.017 7.55A3.775 3.775 0 0 0 12 8.042zm0 6.291a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
              ></path>
            </svg>
          </div>
          <div class="flex justify-end btn-container">
            <div
              style="width: 30px"
              v-bind:style="
                $i18n.locale !== 'en'
                  ? { position: 'relative', left: '-42px' }
                  : {}
              "
            >
              {{ toggles.idle ? $t("message.on") : $t("message.off") }}
            </div>
            <ToggleButton
              v-model="toggles.idle"
              :width="36"
              :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
            />
          </div>
        </div>
      </div>
      <!-- Conditions List for Geofence Notification -->
      <div class="flex column" v-else-if="type === '8'">
        <h3 style="margin-top: 26px">{{ $t("message.conditions") }}</h3>
        <p style="margin-bottom: 26px">
          {{ $t("message.defineTheConditions") }}
        </p>
        <div class="geo flex" style="justify-content: space-between">
          <div class="flex column">
            <div class="geofence-lbl">{{ $t("message.scheduleDays") }}</div>
            <DayOfWeekInput :selectedDays="output.geofence.days" @toggleDay="toggleDay" />
            <div class="flex" style="margin-bottom: 16px">
              <div class="flex column" style="margin-right: 16px">
                <div class="geofence-lbl">{{ $t("message.startTime") }}</div>
                <input
                  type="time"
                  v-model="output.geofence.time.start"
                  class="search-box"
                  style="width: 130px"
                  :disabled="output.geofence.time.allDay"
                />
              </div>
              <div class="flex column" style="margin-right: 16px">
                <div class="geofence-lbl">{{ $t("message.endTime") }}</div>
                <input
                  type="time"
                  v-model="output.geofence.time.end"
                  class="search-box"
                  style="width: 130px"
                  :disabled="output.geofence.time.allDay"
                />
              </div>
              <div class="flex center" style="margin-top: 21px; height: 28px">
                <svg
                  id="gml:icon/checkbox"
                  @click="
                    output.geofence.time.allDay = !output.geofence.time.allDay;
                    $forceUpdate();
                  "
                  style="margin-top: 1px"
                  viewBox="0 0 24 24"
                >
                  <path
                    v-if="output.geofence.time.allDay === false"
                    fill="var(--grey)"
                    d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z"
                  />
                  <path
                    v-else
                    fill="var(--blue)"
                    d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
                  />
                </svg>
                <div>{{ $t("message.allDay") }}</div>
              </div>
            </div>
            <div class="geofence-lbl">{{ $t("message.triggerOn") }}</div>
            <div class="flex" style="margin-top: 16px; margin-bottom: 48px">
              <div class="flex" style="margin-right: 16px">
                <svg
                  id="gml:icon/checkbox"
                  @click="
                    output.geofence.trigger.enter =
                      !output.geofence.trigger.enter;
                    $forceUpdate();
                  "
                  style="margin-top: 2px"
                  viewBox="0 0 24 24"
                >
                  <path
                    v-if="output.geofence.trigger.enter === false"
                    fill="var(--grey)"
                    d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z"
                  />
                  <path
                    v-else
                    fill="var(--blue)"
                    d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
                  />
                </svg>
                <div>{{ $t("message.enter") }}</div>
              </div>
              <div class="flex">
                <svg
                  id="gml:icon/checkbox"
                  @click="
                    output.geofence.trigger.exit =
                      !output.geofence.trigger.exit;
                    $forceUpdate();
                  "
                  style="margin-top: 2px"
                  viewBox="0 0 24 24"
                >
                  <path
                    v-if="output.geofence.trigger.exit === false"
                    fill="var(--grey)"
                    d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z"
                  />
                  <path
                    v-else
                    fill="var(--blue)"
                    d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
                  />
                </svg>
                <div>{{ $t("message.exit") }}</div>
              </div>
            </div>
          </div>
          <div class="us-sample-map">
            <img :src="require('@/assets/' + mapImages[output.geofence.mapId])" />
            <div v-if="output.geofence.mapId === 0" class="map-overlay">
              <div class="map-btn create" @click="showGeofenceSelection = true">
                {{ $t("message.clickToDrawBoundary") }}
              </div>
            </div>
            <div
              v-else
              class="map-btn edit"
              @click="showGeofenceSelection = true"
            >
              <svg id="gfs:icon1/edit" viewBox="0 0 24 24">
                <path
                  d="M16.995 3L5.007 14.997 3 21l6.003-1.998L21 7.005 16.995 3zM5.241 18.759l.9-2.637 1.8 1.8-2.7.837zm3.762-1.8l-1.998-1.962 7.992-7.992 1.998 1.998-7.992 7.956zm6.993-10.953l.999-.999 1.998 1.998-.999.999-1.998-1.998z"
                ></path>
              </svg>
              <span>{{ $t("message.edit") }}</span>
            </div>
          </div>
          <ModalView
            v-if="showGeofenceSelection"
            @hide="showGeofenceSelection = false"
          >
            <GeofenceSelection
              :hideSearch="isMobile"
              :initMapId="output.geofence.mapId"
              @save="save($event)"
              @done="showGeofenceSelection = false"
            />
          </ModalView>
        </div>
      </div>
      <!-- Conditions List for Maintenance Reminder -->
      <div class="flex column" v-else-if="type === '3'">
        <h3 style="margin-top: 26px">{{ $t("message.conditions") }}</h3>
        <p style="margin-bottom: 26px">
          {{ $t("message.setReminderBasedOnVehicleMileage") }}
        </p>
        <div class="speed-condition-grid">
          <div class="mileage-grid" :class="{ visible: output.maintenanceConditions.mileage.enabled }">
            <svg
              id="gml:icon/checkbox"
              @click="
                output.maintenanceConditions.mileage.enabled =
                  !output.maintenanceConditions.mileage.enabled;
                $forceUpdate();
              "
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.maintenanceConditions.mileage.enabled === false"
                fill="var(--grey)"
                d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
              />
            </svg>
            <span
              class="conditions-bold"
              @click="
                output.maintenanceConditions.mileage.enabled =
                  !output.maintenanceConditions.mileage.enabled;
                $forceUpdate();
              "
            >{{ $t("message.odometer") }} *</span>
            <div class="mile-inline-grid">
              <span class="condition-text">{{ $t("message.every") }}</span>
              <input
                v-model="output.maintenanceConditions.mileage.recurrance"
                type="number"
                class="search-box"
                style="width: unset; max-width: unset;"
              />
              <span class="condition-text" style="margin-right: 16px">{{
                $t("message.miles")
              }}</span>
            </div>
            <div class="mile-inline-grid">
              <span class="condition-text">{{ $t("message.startingAtNMiles").split(" {")[0] }}</span>
              <input
                v-model="output.maintenanceConditions.mileage.start"
                type="number"
                class="search-box"
                style="width: unset; max-width: unset;"
              />
              <span class="condition-text">{{ $t("message.miles") }}</span>
            </div>
          </div>
          <div class="time-grid" :class="{ visible: output.maintenanceConditions.time.enabled }">
            <svg
              id="gml:icon/checkbox"
              @click="
                output.maintenanceConditions.time.enabled =
                  !output.maintenanceConditions.time.enabled;
                $forceUpdate();
              "
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.maintenanceConditions.time.enabled === false"
                fill="var(--grey)"
                d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
              />
            </svg>
            <span
              class="conditions-bold"
              @click="
                output.maintenanceConditions.time.enabled =
                  !output.maintenanceConditions.time.enabled;
                $forceUpdate();
              "
            >{{ $t("message.time") }}</span>
            <div class="flex column" style="grid-column: 2 / 3">
              <span class="condition-text"
                >{{ $t("message.remindEvery") }}</span
              >
              <div class="flex" style="gap: 10px; margin-top: 4px;">
                <DropDown v-model="output.maintenanceConditions.time.recurrance.amount" :options="timeOptions.amount" />
                <DropDown v-model="output.maintenanceConditions.time.recurrance.unit" :options="timeOptions.unit" />
              </div>
            </div>
            <div class="flex column" style="grid-column: 2 / 3">
              <span class="condition-text">{{ $t("message.startingAtNMiles").split(" {")[0] }}</span>
              <div class="flex column" style="margin-top: 4px;">
                <input
                  type="date"
                  v-model="output.maintenanceConditions.time.start.date"
                  class="search-box"
                  style="width: 182px; margin-bottom: 10px"
                />
                <input
                  type="time"
                  v-model="output.maintenanceConditions.time.start.time"
                  class="search-box"
                  style="width: 182px"
                />
              </div>
            </div>
          </div>
          <div class="mileage-grid" :class="{ visible: output.maintenanceConditions.runtime.enabled }">
            <svg
              id="gml:icon/checkbox"
              @click="
                output.maintenanceConditions.runtime.enabled =
                  !output.maintenanceConditions.runtime.enabled;
                $forceUpdate();
              "
              viewBox="0 0 24 24"
            >
              <path
                v-if="output.maintenanceConditions.runtime.enabled === false"
                fill="var(--grey)"
                d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z"
              />
              <path
                v-else
                fill="var(--blue)"
                d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
              />
            </svg>
            <span
              class="conditions-bold"
              @click="
                output.maintenanceConditions.runtime.enabled =
                  !output.maintenanceConditions.runtime.enabled;
                $forceUpdate();
              "
            >{{ $t("message.engineHours").charAt(0).toUpperCase() + $t("message.engineHours").slice(1).toLowerCase() }} *</span>
            <div class="mile-inline-grid">
              <span class="condition-text">{{ $t("message.every") }}</span>
              <input
                v-model="output.maintenanceConditions.runtime.recurrance"
                type="number"
                class="search-box"
                style="width: unset; max-width: unset;"
              />
              <span class="condition-text" style="margin-right: 16px">{{ $t("message.hours") }}</span>
            </div>
            <div class="mile-inline-grid">
              <span class="condition-text">{{ $t("message.startingAtNMiles").split(" {")[0] }}</span>
              <input
                v-model="output.maintenanceConditions.runtime.start"
                type="number"
                class="search-box"
                style="width: unset; max-width: unset;"
              />
              <span class="condition-text">{{ $t("message.hours") }}</span>
            </div>
          </div>
          <p style="margin-top: 10px; margin-bottom: 4px; font-size: 15px">
            {{ $t("message.forSupportedVehicles") }}
          </p>
        </div>
      </div>
      <!-- Conditions List for Location Masking Notification -->
      <div class="flex column" v-if="type === '9'">
        <h3 style="margin-top: 26px">{{ $t("message.conditions") }}</h3>
        <div style="font-size: 15px">
          <p>{{ $t('message.locationMaskingNotificationsAreTriggeredWhen') }}</p>
          <div class="condition-grid">
            <svg id="gfs:icon1/location-masking-enabled" viewBox="0 0 24 24">
              <path
                d="M12 3.4a6.7 6.7 0 016.6 6.81c0 2.5-2.07 5.74-6.18 9.82l-.42.42-.42-.42C7.48 15.95 5.4 12.7 5.4 10.2A6.7 6.7 0 0112 3.4zm0 1.2a5.5 5.5 0 00-5.4 5.61c0 1.96 1.72 4.75 5.17 8.31l.23.23.22-.23c3.36-3.45 5.07-6.18 5.17-8.13l.01-.18A5.5 5.5 0 0012 4.6zm0 2.28a3.1 3.1 0 110 6.2 3.1 3.1 0 010-6.2zm0 1.2a1.9 1.9 0 100 3.8 1.9 1.9 0 000-3.8z">
              </path>
            </svg>
            <span>{{ $t('message.locationMasking') }} {{ $t('message.enabled') }}</span>
            <div />
            <div />
            <svg id="gfs:icon1/location-masking-disabled" viewBox="0 0 24 24">
              <path
                d="M13.88 9.73l.97-.97 1.34-1.34 1.18-1.17 1.67-1.67.85.84-1.9 1.91c.39.87.61 1.85.61 2.88 0 2.42-1.96 5.56-5.84 9.48l-.34.34-.42.42-.42-.42a42.82 42.82 0 01-3.01-3.29L5.42 19.9l-.84-.85 9.3-9.3zm3.18-1.48l-1.97 1.97a3.1 3.1 0 01-2.85 2.85L9.42 15.9c.57.7 1.23 1.45 1.98 2.24l.38.4.22.22.23-.23c3.25-3.34 4.96-6.01 5.15-7.95l.02-.18v-.18a5.8 5.8 0 00-.34-1.96zM12 3.4c1.79 0 3.4.73 4.6 1.92l-.85.85A5.28 5.28 0 0012 4.6a5.5 5.5 0 00-5.4 5.61c0 1.02.46 2.26 1.39 3.72l-.87.86c-1.14-1.74-1.72-3.26-1.72-4.58A6.7 6.7 0 0112 3.4zm0 3.48c.84 0 1.6.34 2.16.88l-.85.85a1.9 1.9 0 00-2.69 2.69l-.84.84A3.09 3.09 0 0112 6.88z">
              </path>
            </svg>
            <span>{{ $t('message.locationMasking') }} {{ $t('message.disabled') }}</span>
          </div>
        </div>
        <p style="margin-bottom: 16px; font-size: 15px">
          {{ $t("message.forSupportedVehicles") }}
        </p>
      </div>
      <!-- Conditions List for Vehicle Utilization Notification -->
      <div class="flex column" v-else-if="type === '10'">
        <h3 style="margin-top: 26px">{{ $t("message.conditions") }}</h3>
        <p style="margin-bottom: 26px">
          {{ $t("message.defineTheConditions") }}
        </p>
        <div class="flex" style="align-items: center; margin-bottom: 16px;">
          {{ $t('message.notifyWhenNoTripInMoreThan') }}
          <input type="number" v-model.number="output.lastTripRecorded" class="search-box" style="width: 40px; margin: 0 8px;" />
          {{ $t('message.days') }}
        </div>
      </div>
      <!-- Conditions List for Off Hours Notification -->
      <div class="flex column" v-else-if="type === '11'">
        <h3 style="margin-top: 26px">{{ $t("message.conditions") }}</h3>
        <p style="margin-bottom: 26px">
          {{ $t('message.definesWeeklyWorkingHours') }}
        </p>
        <div class="flex column">
          <div class="geofence-lbl">{{ $t('message.workingDays') }}</div>
          <DayOfWeekInput :selectedDays="output.geofence.days" @toggleDay="toggleDay" />
          <div class="flex" style="margin-bottom: 16px">
            <div class="flex column" style="margin-right: 16px">
              <div class="geofence-lbl">{{ $t("message.startTime") }}</div>
              <input type="time" v-model="output.geofence.time.start" class="search-box" style="width: 130px" />
            </div>
            <div class="flex column" style="margin-right: 16px">
              <div class="geofence-lbl">{{ $t("message.endTime") }}</div>
              <input type="time" v-model="output.geofence.time.end" class="search-box" style="width: 130px" />
            </div>
          </div>
        </div>
      </div>
      <!-- Conditions List for Driving Limit Notification -->
      <div class="flex column" v-else-if="type === '12'">
        <h3 style="margin-top: 26px">{{ $t("message.conditions") }}</h3>
        <p style="margin: 0;">{{ $t("message.defineTheConditions") }}</p>
        <p style="margin-bottom: 26px">
          {{ $t('message.notificationsTriggeredAtEndOfTripWhichExceededLimit') }}
        </p>
        <div class="flex" style="align-items: center; gap: 8px;">
          <span>{{ $t('message.notifyWhenDrivenMoreThan') }}</span>
          <input
            v-model.number="output.drivingLimit.number"
            type="number"
            class="search-box"
            style="width: 30px; height: 30px; margin: 0;"
          />
          <DropDown v-model="output.drivingLimit.unit" :options="drivingLimitDropdown.unit.options" />
          <span>{{ $t('message.inOne') }}</span>
          <DropDown v-model="output.drivingLimit.per" :options="drivingLimitDropdown.per.options" style="text-transform: lowercase" />
        </div>
        <div class="flex" style="align-items: center; margin: 12px 0 24px 0; gap: 8px;">
          <span>{{ $t('message.startOfWeek') }}</span>
          <DropDown v-model="output.drivingLimit.startOfWeek" :options="drivingLimitDropdown.startOfWeek.options" />
        </div>
      </div>
      <div class="line" v-if="typeNumber !== 10" />
      <div v-if="typeNumber !== 10">
        <h3 style="margin: 16px 0 10px 0">{{ $t("message.driverNotification") }}</h3>
        <div
          class="flex"
          style="justify-content: space-between; margin-bottom: 10px"
        >
          <!-- <svg
            id="gml:icon/checkbox"
            @click="output.sendToActive = !output.sendToActive; $forceUpdate();"
            viewBox="0 0 24 24"
          >
            <path
              v-if="output.sendToActive === false"
              fill="var(--grey)"
              d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z"
            />
            <path
              v-else
              fill="var(--blue)"
              d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
            />
          </svg> -->
          <div class="flex" style="align-items: center; gap: 2px;">
            {{ $t("message.notifyActiveDriverWhenTriggerConditions") }}
            <InfoHoverIcon msg="The driver that is assigned to the vehicle will receive a new notification in the Notifications Center when the trigger conditions are met" />
          </div>
          <div class="flex">
            <div
              style="width: 30px"
              v-bind:style="
                $i18n.locale !== 'en'
                  ? { position: 'relative', left: '-42px' }
                  : {}
              "
            >
              {{ active ? $t("message.on") : $t("message.off") }}
            </div>
            <ToggleButton
              v-model="active"
              :width="36"
              :color="{ checked: '#0072C8', unchecked: '#969FB3' }"
            />
          </div>
        </div>
      </div>
      <div class="action-btn-area">
        <span
          v-if="editingId !== -1"
          @click="showModal = true"
          class="gray-button"
          style="color: var(--red)"
          >{{ $t("message.deleteNotification") }}</span
        >
        <span v-else />
        <div class="flex center">
          <span
            class="gray-button"
            @click="$router.push({ name: 'notification-settings' })"
            >{{ $t("message.cancel") }}</span
          >
          <div
            class="action-button major"
            style="width: unset; padding: 0 16px"
            @click="handleSubmit"
          >
            <!-- {{
              editingId === -1
                ? $t("message.createNotification")
                : $t("message.saveChanges")
            }} -->
            {{ (typeNumber === 8 && editingId === -1) ? $t("message.createGeofence") : $t("message.saveChanges") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { ToggleButton } from "vue-js-toggle-button";

import ModalView from "@/components/demo/ModalView.vue";
import VehicleSelection from "@/components/demo/VehicleSelection.vue";
import GeofenceSelection from "@/components/demo/GeofenceSelection.vue";
import DayOfWeekInput from "../../components/demo/DayOfWeekInput.vue";
import DropDown from "../../components/demo/DropDown.vue";
import InfoHoverIcon from "../../components/demo/InfoHoverIcon.vue";

export default {
  props: {
    dataset: Object,
    isMobile: Boolean,
    title: String,
    type: String, // because route params sometimes convert to strings on their own
    editing: String, // ^
    challenges: Array,
    activeChallenge: String,
    numIncomplete: Number,
    timeLeft: Number,
    multiplier: Number,
  },
  components: {
    ModalView,
    ToggleButton,
    VehicleSelection,
    GeofenceSelection,
    DayOfWeekInput,
    DropDown,
    InfoHoverIcon,
},
  data() {
    return {
      // vehicleDropdownOpen: false,
      showVehicleSelection: false,
      showGeofenceSelection: false,
      managerDropdownOpen: false,
      stateKeys: [
        "diagnosticNotifications",
        "", // "eventThresholdNotifications",
        "maintenanceReminderNotifications",
        "",
        "",
        "",
        "driverBehaviorNotifications",
        "geofenceNotifications",
        "locationMaskingNotifications",
        "vehicleUtilizationNotifications",
        "offHoursNotifications",
        "drivingLimitNotifications"
      ],
      stateCreateNewKeys: [
        "newDiagnosticNotification",
        "", // "newEventThresholdNotification",
        "newMaintenanceReminderNotification",
        "",
        "",
        "",
        "newDriverBehaviorNotification",
        "newGeofenceNotification",
        "newLocationMaskingNotification",
        "newVehicleUtilitizationNotification",
        "newOffHoursNotification",
        "newDrivingLimitNotification"
      ],
      stateUpdateKeys: [
        "updateDiagnosticNotification",
        "", // "updateEventThresholdNotification",
        "updateMaintenanceReminderNotification",
        "",
        "",
        "",
        "updateDriverBehaviorNotification",
        "updateGeofenceNotification",
        "updateLocationMaskingNotification",
        "updateVehicleUtilizationNotification",
        "updateOffHoursNotification",
        "updateDrivingLimitNotification"
      ],
      stateDeleteKeys: [
        "deleteDiagnosticNotification",
        "", // "deleteeventThresholdNotification",
        "deleteMaintenanceReminderNotification",
        "",
        "",
        "",
        "deleteDriverBehaviorNotification",
        "deleteGeofenceNotification",
        "deleteLocationMaskingNotification",
        "deleteVehicleUtilizationNotification",
        "deleteOffHoursNotification",
        "deleteDrivingLimitNotification"
      ],
      mileageOptions: [
        1000, 5000, 10000, 12000, 15000, 20000, 40000, 50000, 100000,
      ],
      mileageDropdownOpen: false,
      timeOptions: {
        amount: [1, 2, 3, 4, 5, 12, 18, 24, 30, 36],
        unit: ["months", "weeks"],
      },
      timeFirstDropdownOpen: false,
      timeSecondDropdownOpen: false,
      showModal: false,
      bingo: false,
      activeVar: false,
      drivingLimitDropdown: {
        unit: {
          open: false,
          options: ['hours', 'miles'],
        },
        per: {
          open: false,
          options: ['day', 'week'],
        },
        startOfWeek: {
          open: false,
          options: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        },
      },
      mapImages: [
        'us-map-sample.png',
        'city-detroit.png',
        'county-wayne.png',
        'state-mi.png',
        'country-usa.png',
        'zip-midtown.png',
        'radius.png',
        'region-med-ctr.png',
      ],
      output: {
        name: '',
        allVehicles: true,
        selectedVehicles: [],
        sendToActive: false,
        allManagers: true,
        onlyMe: false,
        selectedManagers: [],
        speedConditions: {
          active: "fixed",
          fixed: 80,
          road: 5,
        },
        maintenanceConditions: {
          mileage: {
            enabled: false,
            recurrance: 8000,
            start: 0,
          },
          time: {
            enabled: false,
            recurrance: {
              amount: 6,
              unit: "months",
            },
            start: {
              date: moment().format("YYYY-MM-DD"),
              time: moment().format("HH:mm:ss"),
            },
          },
          runtime: {
            enabled: false,
            recurrance: 150,
            start: 0,
          },
        },
        geofence: {
          days: [true, true, true, true, true, true, true],
          time: {
            allDay: true,
            start: moment("8:00", "HH:mm").format("HH:mm"),
            end: moment("20:00", "HH:mm").format("HH:mm"),
          },
          trigger: {
            enter: true,
            exit: true,
          },
          mapId: 0,
        },
        lastTripRecorded: 4,
        drivingLimit: {
          number: 9,
          unit: 'hours',
          per: 'week',
          startOfWeek: 'Monday',
        },
        toggles: {
          brake: false,
          accel: false,
          seatbelt: false,
          fixedSpeed: false,
          roadSpeed: false,
        },
      },
    };
  },
  computed: {
    typeNumber() {
      if (this.type) return parseInt(this.type);
      return -1;
    },
    // typeStr() {
    //   if (this.typeNumber === 1) return this.$t("message.diagnostics");
    //   // if (this.typeNumber === 2) return " Driver Speeding ";
    //   if (this.typeNumber === 3) return this.$t("message.maintenanceReminder");
    //   if (this.typeNumber === 7) return this.$t("message.driverBehavior");
    //   if (this.typeNumber === 8) return this.$t("message.geofence");
    //   if (this.typeNumber === 9) return "Location Masking";
    //   if (this.typeNumber === 10) return "Vehicle Utilization";
    //   if (this.typeNumber === 11) return "Off-Hours";
    //   if (this.typeNumber === 12) return "Driving Limit";
    //   return " ";
    // },
    defaultName() {
      if (this.$route.params.title) {
        return this.$t('message.alertType').replace('_____', this.$route.params.title);
      }
      return this.$t('message.alertType');
    },
    editingId() {
      if (this.editing) return parseInt(this.editing);
      return -1;
    },
    active: {
      get() {
        if (this.activeVar) return this.activeVar;
        return this.output.sendToActive;
      },
      set(data) {
        this.output.sendToActive = data;
        this.activeVar = data;
      },
    },
    toggles() {
      if (this.output.toggles) return this.output.toggles;
      return null;
    },
  },
  methods: {
    addItemToMultichoose(item, multichoose) {
      if (this.output[multichoose].indexOf(item) === -1) {
        this.output[multichoose].push(item);
      }
    },
    removeItemFromMultichoose(item, multichoose) {
      const index = this.output[multichoose].indexOf(item);
      if (index !== -1) {
        this.output[multichoose].splice(index, 1);
      }
    },
    goToSpeedPage() {
      if (
        confirm(
          "Are you sure you want to leave this page? Press OK to save your changes and continue, or cancel to stay on the page."
        )
      ) {
        this.handleSubmit(true);
        this.$router.push({
          name: "notification-settings",
          params: { type: 2 },
        });
      }
    },
    handleSubmit(goToSpeed) {
      // let name = this.output.name.toLowerCase();
      // let mileage = Number(
      //   this.output.maintenanceConditions.mileage.recurrance
      // );
      // let malibu102Selected = false;

      // for (let i = 0; i < this.output.selectedVehicles.length; i++) {
      //   if (this.output.selectedVehicles[i] === "Malibu 102") {
      //     malibu102Selected = true;
      //   }
      // }
      // if (this.activeChallenge === "delegate" && this.type === "3") {
      //   this.bingo = true;
      //   this.$emit("challengeComplete", 13);
      //   this.$emit("pauseTimer");
      // } else if (
      //   this.activeChallenge === "be-a-know-it-all" &&
      //   this.type === "1"
      // ) {
      //   this.bingo = true;
      //   this.$emit("challengeComplete", 4);
      //   this.$emit("pauseTimer");
      // } else if (
      //   this.activeChallenge === "its-great-to-rotate" &&
      //   mileage === 5000 &&
      //   name === "rotate tires"
      // ) {
      //   this.$emit("challengeComplete", 23);
      //   this.$emit("pauseTimer");
      //   this.bingo = true;
      //   this.$emit("bingo");
      // } else if (
      //   this.activeChallenge === "whats-the-diagnosis" &&
      //   malibu102Selected
      // ) {
      //   this.$emit("challengeComplete", 20);
      //   this.$emit("pauseTimer");
      //   this.bingo = true;
      //   this.$emit("bingo");
      // } else if (
      //   this.activeChallenge === "be-on-the-alert" &&
      //   (this.togglesVar.accel ||
      //     this.togglesVar.brake ||
      //     this.togglesVar.fixedSpeed ||
      //     this.togglesVar.roadSpeed ||
      //     this.togglesVar.seatbelt)
      // ) {
      //   this.$emit("challengeComplete", 15);
      //   this.$emit("pauseTimer");
      //   this.bingo = true;
      //   this.$emit("bingo");
      // } else {
      if (this.editingId === -1) {
        this.$store.commit(
          this.stateCreateNewKeys[this.typeNumber - 1],
          this.output
        );
        if (goToSpeed !== true)
          this.$router.push({
            name: "notification-settings",
            params: { addedNew: true },
          });
      } else {
        // handle update
        if (goToSpeed !== true)
          this.$router.push({
            name: "notification-settings",
            params: { edited: true },
          });
      }
      // }
    },
    handleDelete() {
      this.$store.commit(
        this.stateDeleteKeys[this.typeNumber - 1],
        this.output
      );
      this.$router.push({
        name: "notification-settings",
        params: { deleted: true },
      });
    },
    toggleDay(dayIndex) {
      // this.output.geofence.days[dayIndex] =
      //   !this.output.geofence.days[dayIndex];
      // this.$forceUpdate();
      this.$set(this.output.geofence.days, dayIndex, !this.output.geofence.days[dayIndex]);
    },
    save($event) {
      if (this.activeChallenge === "dont-go-too-far" && $event === 2) {
        this.$emit("challengeComplete", 19);
        this.$emit("pauseTimer");
        this.bingo = true;
        this.$emit("bingo");
        this.output.geofence.mapId = $event;
        this.$forceUpdate();
      }
      this.output.geofence.mapId = $event;
      this.$forceUpdate();
    },
  },
  created() {
    if (!this.title) this.$router.replace(({ name: 'notification-settings' }));
    if (this.editingId !== -1 && this.typeNumber !== -1) {
      const index = this.$store.state[
        this.stateKeys[this.typeNumber - 1]
      ].findIndex((item) => item.id === this.editingId);
      this.output = this.$store.state[this.stateKeys[this.typeNumber - 1]][index];
    } else {
      this.output.name = this.defaultName
    }
    window.scrollTo(0, 0);
  },
  watch: {
    numIncomplete() {
      if (this.numIncomplete === 0) {
        this.$emit("noMoreChallenges");
      }
    },
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
}
.content {
  display: flex;
  flex-direction: column;
  margin: 0 80px;
}
@media screen and (max-width: 1112px) {
  .content {
    margin: 0 5%;
  }
}
h3 {
  font-size: 16px;
  margin: 0;
}
h3 span {
  font-weight: unset;
  font-size: 15px;
  color: var(--red);
}
p {
  margin-top: 0;
  margin-bottom: 18px;
  font-size: 13px;
  color: var(--dark-grey);
}
.search-box {
  width: 393px;
  max-width: 95%;
}
svg {
  cursor: pointer;
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
/* .multichoose-item {
  background-color: var(--light-grey-2);
  padding: 2px 8px;
  margin-right: 6px;
  margin-top: 2px;
  font-size: 13px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}
.dropdown-search {
  position: absolute;
  top: 5px;
  right: 3px;
  fill: var(--dark-grey);
  width: 24px;
  height: 24px;
}
.multichoose-item svg {
  width: 13px;
  height: 13px;
  margin-left: 4px;
  cursor: pointer;
} */
.toggle-grid {
  display: grid;
  grid-template-columns: 48px 1fr 121px;
  grid-auto-rows: 80px 1px;
  align-items: center;
}
@media screen and (max-width: 675px) {
  .toggle-grid {
    grid-auto-rows: minmax(80px, auto) 1px;
  }
}
.toggle-grid .item {
  margin: 8px 8px 8px 0;
}
.toggle-grid svg {
  width: 32px;
  height: 32px;
  fill: var(--dark-grey);
  cursor: default;
}
.toggle-grid .separator {
  width: 100%;
  height: 100%;
  grid-column: 1 / 5;
  background-color: var(--light-grey-2);
}
.line {
  width: 100%;
  height: 1px;
  background-color: var(--light-grey-2);
}
.condition-grid {
  display: grid;
  grid-template-columns: 18px 1fr 18px 1fr;
  gap: 4px;
  margin: 16px 0 24px 0;
}
.condition-grid svg {
  width: 14px;
  height: 14px;
  margin: 0;
  align-self: center;
}
.bullet-spacer {
  margin-right: 15px;
}
.action-btn-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 26px 0 36px 0;
  border-top: 1px solid var(--light-grey-2);
  padding-top: 10px;
}
.gray-button {
  font-weight: 600;
  color: var(--dark-grey);
  cursor: pointer;
}
.action-button {
  width: 156px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid var(--blue);
  background-color: var(--blue);
  color: var(--white);
  margin-left: 24px;
  margin-right: 4px;
}
.action-button.minor {
  background-color: var(--white);
  border-color: var(--light-grey);
  color: var(--blue);
  width: 106px;
  margin-right: 0;
}
.geofence-lbl {
  color: var(--dark-grey);
}
.speed-condition-grid {
  margin-bottom: 16px;
  /* display: grid; */
  /* grid-template-columns: 30px auto;
  grid-template-rows: 30px 50px 30px 50px 30px; */
  /* grid-template-columns: 1fr 1fr; */
  /* height: 260px; */
}
/* @media screen and (max-width: 935px) {
  .speed-condition-grid {
    grid-template-columns: 1fr;
    height: 380px;
  }
} */
.mileage-grid {
  display: grid;
  grid-template-rows: 24px 30px 50px;
  grid-template-columns: 20px 1fr;
  gap: 10px;
  height: 30px;
  overflow: hidden;
}
.mileage-grid.visible {
  height: unset;
  overflow: unset;
}
.mile-inline-grid {
  grid-column: 2 / 3;
  display: grid;
  grid-template-columns: 75px 100px 35px;
  gap: 16px;
}
.time-grid {
  display: grid;
  grid-template-rows: 24px 70px 120px;
  grid-template-columns: 20px 1fr;
  gap: 10px;
  height: 30px;
  overflow: hidden;
}
.time-grid.visible {
  height: unset;
  overflow: unset;
}
.conditions-bold {
  /* text-transform: capitalize; */
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;
}
.condition-text {
  margin-top: 4px;
}
.modal {
  width: 400px;
  height: 237px;
}
.modal .close {
  width: 14px;
}
.modal .modal-text {
  margin-top: -8px;
  padding: 0 20px 16px 20px;
  font-size: 15px;
  border-bottom: 1px solid #b3cfe6;
}
.modal h3 {
  font-size: 21px;
  margin: 10px 0;
}
.edit-btn {
  font-weight: 600;
  color: var(--blue);
  margin-left: 8px;
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  .flex.geo {
    flex-direction: column;
  }
  .us-sample-map {
    margin: 0 auto 32px auto;
  }
}
.us-sample-map {
  width: 100%;
  max-width: 425px;
  height: 273px;
  position: relative;
}
.us-sample-map img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.us-sample-map .map-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}
.us-sample-map .map-btn {
  font-weight: 600;
  color: var(--blue);
  height: 30px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 4px;
  border: 1px solid var(--light-grey);
  cursor: pointer;
  transition: border-color 0.5s, color 0.5s;
}
.us-sample-map .map-btn.edit {
  padding: 0 12px;
  height: 28px;
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.us-sample-map .map-btn.edit svg {
  width: 18px;
  height: 18px;
  fill: var(--blue);
  transition: fill 0.5s;
}
.us-sample-map .map-btn.edit span {
  margin-bottom: 1px;
  margin-right: 4px;
}
.us-sample-map .map-btn:hover {
  border-color: #05b5e4;
  color: #05b5e4;
}
.us-sample-map .map-btn.edit:hover svg {
  fill: #05b5e4;
}
.action-button.learn-more {
  width: auto;
}
.btn-container {
  width: 100%;
  /* padding-left: 35px; */
}
</style>
